import { render, staticRenderFns } from "./accommodationsPage.vue?vue&type=template&id=3d5694a6"
import script from "./accommodationsPage.vue?vue&type=script&lang=js"
export * from "./accommodationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports